export const $comein = (function () {
	//声明comein 返回值
	var comein = {};
	comein.genKey = function () {
		return 'id_' + 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0,
				v = c == 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	};
	//注册access
	comein.register = function (access) {
		comein.access = access;
	};
	//发送事件给native 流程 iframe->mainframe->native  响应 native->main frame->iframe
	comein.event = function (method, param, callback) {
		//不重复的 event id
		var id = comein.genKey();
		//绑定callback 到 id
		comein[id] = callback;
		//把这个消息发送到main frame
		top.postMessage({
			"type": "$comein_req",
			"payload": {
				"id": id,
				"body": {
					"access": comein.access,
					"method": method,
					"param": param
				}
			}
		}, "*");
	};
	/*
	native端回应会调用该函数 参数为json字串 格式为以下
	{
	    "id":"这个是main frame<->native",
	    "body":{
	        "code":0,
	        "desc":"成功",
	        "data":{}
	    }
	}
	*/
	comein.ack = function (json) {
		var res = JSON.parse(json);
		var id = res["id"];
		if (id) {
			var cache = comein[id];
			if (cache) {
				//把这个消息发送到关联的frame
				cache["wind"].postMessage({
					"type": "$comein_resp",
					"payload": {
						"id": cache["id"],
						"body": res["body"]
					}
				}, "*");
				delete comein[id];
			}
		}
	};
	//iframe 和 mainframe 的消息互通
	window.addEventListener("message", function (event) {
		if (typeof (event.data) != "object") return;
		var data = event["data"];
		var type = data["type"];
		var payload = data["payload"];
		if (type == "$comein_req") {
			//两个id 分别作用于 iframe自己  mainframe<->native
			var id = payload["id"];
			var cache_id = "cache_" + id;
			comein[cache_id] = {
				"id": id,
				"wind": event["source"]
			};
			var message = {
				"id": cache_id,
				"body": payload["body"]
			};
			//发送到native 判断定义了$comein_bridge 就是安卓
			if (window.$comein_bridge) {
				window.$comein_bridge.postMessage(JSON.stringify(message));
			} else if (window.webkit.messageHandlers.$comein_bridge) {
				window.webkit.messageHandlers.$comein_bridge.postMessage(JSON.stringify(message));
			}
		} else if (type == "$comein_resp") {
			var id = payload["id"];
			var callback = comein[id];
			if (!callback) return;
			var body = payload["body"];
			callback(body["code"], body["desc"], body["data"]);
			delete comein[id];
		}
	});
	return comein;
})();
